import { render, staticRenderFns } from "./myInvoiceDetails.vue?vue&type=template&id=387ec063&scoped=true&"
import script from "./myInvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./myInvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./myInvoiceDetails.vue?vue&type=style&index=0&id=387ec063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ec063",
  null
  
)

export default component.exports